
import { Brain } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PremiumBadge } from "./premium-badge";
import { useNavigate } from "react-router-dom";
import { useLanguagePath } from "@/utils/language";
import { useLanguage } from "@/components/LanguageContext";
import { useTranslations } from "@/hooks/useTranslations";

interface PremiumFeatureDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  featureName: string;
  icon?: React.ReactNode;
}

export function PremiumFeatureDialog({
  open,
  onOpenChange,
  featureName,
  icon = <Brain className="h-5 w-5 text-amber-500" />
}: PremiumFeatureDialogProps) {
  const navigate = useNavigate();
  const { getPath } = useLanguagePath();
  const { language } = useLanguage();
  const { t } = useTranslations("dashboard");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {icon}
            {t("premium.dialog.title")}
          </DialogTitle>
          <DialogDescription>
            {t(`premium.dialog.featureDescription.${featureName}`)} {t("premium.dialog.exclusiveFeature")}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center my-4">
          <PremiumBadge className="text-lg py-2 px-4" />
        </div>
        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            {t("premium.dialog.close")}
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate(getPath('/dashboard/plan'));
            }}
            className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-white"
          >
            {t("premium.dialog.upgrade")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
